import { api } from "utils/api";

export const getCompanySettings = () => api.get("/company/settings");

export const updateCompanySettings = (data: any) => api.put("/company/settings/", data);

export const addCompanySettings = (data: any) => api.post("/company/settings/", data);

export const getStamp = () =>
  api.get("/company/settings/stamp", undefined, {
    responseType: "blob",
  });

export const addStamp = (data: any) =>
  api.post(`/company/settings/stamp`, data, { headers: { "Content-Type": "multipart/form-data" } });

export const deleteStamp = () => api.delete("/company/settings/stamp");

export const getSignature = () =>
  api.get("/company/settings/signature", undefined, {
    responseType: "blob",
  });

export const addSignature = (data: any) =>
  api.post(`/company/settings/signature`, data, { headers: { "Content-Type": "multipart/form-data" } });

export const deleteSignature = () => api.delete("/company/settings/signature");

export const getLogo = () =>
  api.get("/company/settings/logo", undefined, {
    responseType: "blob",
  });

export const addLogo = (data: any) =>
  api.post(`/company/settings/logo`, data, { headers: { "Content-Type": "multipart/form-data" } });

export const deleteLogo = () => api.delete("/company/settings/logo");
